import { useEffect } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import WhyUs from "@/components/WhyUs";
import Reviews from "@/components/Reviews";
import ServiceAreas from "@/components/ServiceAreas";
import Faq from "@/components/Faq";
import GuidesSection from "@/components/GuidesSection";
import RequestForm from "@/components/RequestForm";
import Footer from "@/components/Footer";
import FloatingCallBar from "@/components/FloatingCallBar";

export default function Home() {
  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.slice(1);
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 400);
    }
  }, []);

  return (
    <div className="bg-[#FAFAFA] pb-16 md:pb-0" data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <WhyUs />
        <Reviews />
        <ServiceAreas />
        <Faq />
        <GuidesSection />
        <RequestForm />
      </main>
      <Footer />
      <FloatingCallBar />
    </div>
  );
}
